import * as C from '../constants';

export const profileListReset = () => ({
  type: C.RESET_PROFILE_LIST,
});

export const resetProfileList = () => (dispatch) => {
  dispatch(profileListReset());
};
